const MUTATIONS = {
  //Settings
  setLanguage(state, lang) {
    state.language = lang;
  },
  setAppBusy(state, isBusy) {
    state.appBusy = isBusy ? true : false;
  },


  //User Related
  setMobileNumber(state, mobileNumber) {
    state.user.mobileNumber = mobileNumber;
  },
  setUserUUID(state, userUUID) {
    state.user.uuid = userUUID;
  },
  setLoginToken(state, loginToken) {
    state.user.loginToken = loginToken;
  },
  setLoggedIn(state, loggedIn) {
    state.user.loggedIn = loggedIn;
  },
  setIsIntroTaken(state) {
    state.user.isIntroTaken = true;
  },


  //Database Management
  saveState(state) {
    localStorage.setItem("dataSaved", true);
    localStorage.setItem("dateTime", Date.now());
    localStorage.setItem("state", JSON.stringify(state));
  },
  loadState(state) {
    Object.assign(state, JSON.parse(localStorage.getItem("state")));
  },
  clearState() {
    localStorage.setItem("dataSaved", false);
  },


  //Add Device
  setScannedQR(state, scannedQR) {
    if( scannedQR ){
      state.scannedQR = {};
      Object.assign(state.scannedQR, scannedQR);
    }else{
      state.scannedQR = null;
    }
  },


  //Hub Related
  addHub(state, hub) {
    state.hubs.push(hub);
  },
  deleteHub(state, hubIndex) {
    state.hubs.splice(hubIndex, 1);
  },
  SetTempHubPassword(state, hubPassword) {
    state.tempHub.password = hubPassword;
  },
  SetTempHubMasterUUID(state, masterUUID) {
    state.tempHub.masterUUID = masterUUID;
  },
  SetTempHubNameColor(state, hubNameColor) {
    state.tempHub.name = hubNameColor.name;
    state.tempHub.color = hubNameColor.color;
  },
  setHubName(state, contex) {
    state.hubs[contex.hubIndex].name = contex.name;
  },
  setHubColor(state, contex) {
    state.hubs[contex.hubIndex].color = contex.color;
  },
  addNewUserToHub(state, contex) {
    state.hubs[contex.hubIndex].users.push({
      mobile: contex.mobile,
      name: contex.name,
      isOwner: contex.isOwner,
      uuid: contex.uuid,
    });
  },
  setUserName(state, contex) {
    state.hubs[contex.hubIndex].users[contex.userIndex].name = contex.name;
  },
  setAllHubUsers(state, contex) {
    state.hubs[contex.hubIndex].users = contex.users;
  },
  deleteUser(state, contex) {
    state.hubs[contex.hubIndex].users.splice(contex.userIndex, 1);
  },
  setHubInputs(state, contex) {
    const node = state.nodes.find(x => x.uuid === contex.uuid);
    if (node && Array.isArray(node.inputs) && Array.isArray(contex.inputs)) {
      contex.inputs.forEach(newInput => {
        const idx = node.inputs.findIndex(input => input.parameterId === newInput.parameterId);
        if (idx !== -1) {
          node.inputs[idx] = { ...node.inputs[idx], ...newInput };
        } else {
          node.inputs.push({ ...newInput });
        }
      });
    }
  },
  setHubOutputs(state, contex) {
    const node = state.nodes.find(x => x.uuid === contex.uuid);
    if (node && Array.isArray(node.outputs) && Array.isArray(contex.outputs)) {
      contex.outputs.forEach(newOutput => {
        const idx = node.outputs.findIndex(output => output.parameterId === newOutput.parameterId);
        if (idx !== -1) {
          node.outputs[idx] = { ...node.outputs[idx], ...newOutput };
        } else {
          node.outputs.push({ ...newOutput });
        }
      });
    }
  },
  setHubStatus(state, hubStatusContex) {
    if(hubStatusContex.connectionStatus !== undefined) {
      if(hubStatusContex.connectionStatus.local !== undefined) {
        state.hubs[hubStatusContex.hubIndex].connectionStatus.local = hubStatusContex.connectionStatus.local;
      }
      if(hubStatusContex.connectionStatus.online !== undefined) {
        state.hubs[hubStatusContex.hubIndex].connectionStatus.online = hubStatusContex.connectionStatus.online;
      }
    }
    if(hubStatusContex.stateUpdateEnabled !== undefined) {
      state.hubs[hubStatusContex.hubIndex].stateUpdateEnabled = hubStatusContex.stateUpdateEnabled;
    }
    if(hubStatusContex.stateUpdatePending !== undefined) {
      state.hubs[hubStatusContex.hubIndex].stateUpdatePending = hubStatusContex.stateUpdatePending;
    }
    if(hubStatusContex.ipAddress !== undefined) {
      state.hubs[hubStatusContex.hubIndex].ipAddress = hubStatusContex.ipAddress;
    }
    if(hubStatusContex.isMQTTConnected !== undefined){
      state.hubs[hubStatusContex.hubIndex].isMQTTConnected = hubStatusContex.isMQTTConnected;
    }
    if(hubStatusContex.isMQTTConnected !== undefined){
      state.hubs[hubStatusContex.hubIndex].isMQTTConnected = hubStatusContex.isMQTTConnected;
    }
    if(hubStatusContex.firmWareYear !== undefined){
      state.hubs[hubStatusContex.hubIndex].firmWareYear = hubStatusContex.firmWareYear;
    }
    if(hubStatusContex.firmWareMonth !== undefined){
      state.hubs[hubStatusContex.hubIndex].firmWareMonth = hubStatusContex.firmWareMonth;
    }
    if(hubStatusContex.wifiType !== undefined){
      state.hubs[hubStatusContex.hubIndex].wifiType = hubStatusContex.wifiType;
    }
    if(hubStatusContex.ssid !== undefined){
      state.hubs[hubStatusContex.hubIndex].ssid = hubStatusContex.ssid;
    }
    if(hubStatusContex.dateStamp !== undefined){
      state.hubs[hubStatusContex.hubIndex].dateStamp = hubStatusContex.dateStamp;
    }
    if(hubStatusContex.timeStamp !== undefined){
      state.hubs[hubStatusContex.hubIndex].timeStamp = hubStatusContex.timeStamp;
    }
    if(hubStatusContex.networkAddress !== undefined){
      state.hubs[hubStatusContex.hubIndex].networkAddress = hubStatusContex.networkAddress;
    }
    if(hubStatusContex.staticIp !== undefined){
      state.hubs[hubStatusContex.hubIndex].staticIp = hubStatusContex.staticIp;
    }
    if(hubStatusContex.port !== undefined){
      state.hubs[hubStatusContex.hubIndex].port = hubStatusContex.port;
    }
    if(hubStatusContex.ioInfo !== undefined){
      state.hubs[hubStatusContex.hubIndex].ioInfo = hubStatusContex.ioInfo;
    }
  },
  cancelAllStateUpdates(state) {
    for(var i = 0; i < state.hubs.length; i++){
      state.hubs[i].stateUpdateEnabled = false;
    }
  },

  //Nodes Related
  addNode(state, node) {
    state.nodes.push(node);
  },
  deleteNode(state, nodeIndex) {
    state.nodes.splice(nodeIndex, 1);
  },
  setTempNodeHubIndex(state, hubIndex) {
    state.tempNode.hubIndex = hubIndex;
  },
  SetTempNodeNameColor(state, nodeNameColor) {
    state.tempNode.name = nodeNameColor.name;
    state.tempNode.color = nodeNameColor.color;
  },
  setNodeName(state, contex) {
    state.nodes[contex.nodeIndex].name = contex.name;
  },
  setNodeColor(state, contex) {
    state.nodes[contex.nodeIndex].color = contex.color;
  },
  setNodeSettings(state, contex) {
    state.nodes[contex.nodeIndex].settings = contex.settings;
  },
  setNodeOutputName(state, contex) {
    state.nodes[contex.nodeIndex].outputs[contex.outputIndex].name = contex.name;
  },
  setNodeOutputType(state, contex) {
    state.nodes[contex.nodeIndex].outputs[contex.outputIndex].settings.outputType = contex.type;
  },
  setNodeInputName(state, contex) {
    state.nodes[contex.nodeIndex].inputs[contex.inputIndex].name = contex.name;
  },
  setNodeInputType(state, contex) {
    state.nodes[contex.nodeIndex].inputs[contex.inputIndex].settings.inputType = contex.type;
  },
  setNodeNotificationStatus(state, contex) {
    state.nodes[contex.nodeIndex].inputs[contex.inputIndex].settings.inputType = contex.type;
  },
  setNodeIsPaired(state, contex) {
    state.nodes[contex.nodeIndex].isPaired = contex.isPaired;
  },
  addOutputToDevice(state, contex) {
    state.nodes[contex.nodeIndex].outputs.push(contex.output);
  },
  editDeviceOutput(state, contex) {
    state.nodes[contex.nodeIndex].outputs[contex.outputIndex].name = contex.output.name;
    state.nodes[contex.nodeIndex].outputs[contex.outputIndex].settings = contex.output.settings;
  },
  DeleteIrDevice(state, contex) {
    state.nodes[contex.nodeIndex].outputs.splice(contex.outputIndex, 1);
  },
  DeleteRfDevice(state, contex) {
    state.nodes[contex.nodeIndex].outputs.splice(contex.outputIndex, 1);
  },
  resetNodeStates(state) {
    for(var i = 0; i < state.nodes.length; i++){
      state.nodes[i].connectionStatus = -1;
      state.nodes[i].rawParameters = [];
    }
  },
  setNodeStateAndParameters(state, contex) {
    state.nodes[contex.nodeIndex].rawParameters = contex.rawParameters;
    state.nodes[contex.nodeIndex].connectionStatus = contex.connectionStatus;
  },
  setNodeParameters(state, contex) {
    state.nodes[contex.nodeIndex].rawParameters = contex.rawParameters;
  },
  setParameterValue(state, contex) {
    var nodeParameters = state.nodes[contex.nodeIndex].rawParameters;
    var parameterLength = nodeParameters.length;
    for(var i = 0; i < parameterLength; i++){
      if(nodeParameters[i].id == contex.parameterId){
        state.nodes[contex.nodeIndex].rawParameters[i].value = contex.parameterValue;
      }
    }
  },

  //Widgets Related
  addWidget(state, widget) {
    state.widgets.push(widget);
  },
  deleteWidget(state, widgetIndex) {
    state.widgets.splice(widgetIndex, 1);
  },
  deleteHubWidget(state, hubUUID) {
    state.widgets = state.widgets.filter(x => x.hubUUID !== hubUUID);
  },
  updateWidgets(state, widgets) {
    state.widgets = widgets;
  },
  editWidget(state, contex) {
    Object.assign(state.widgets[contex.widgetIndex], contex.widget);
  },
  updateWidgetProperty(state, contex) {
    state.widgets[contex.widgetIndex][contex.property] = contex.propertyValue
  },
  editActiveDashboardFolderId(state, folderId) {
    state.activeDashboardFolderId = folderId;
  },
  editWidgetPath(state, contex) {
    state.widgets[contex.widgetIndex].path = contex.path;
  },

  //Schedules Related
  addScenario(state, scenario) {
    state.scenarios.push(scenario);
  },
  deleteScenario(state, scenarioId) {
    state.scenarios = state.scenarios.filter(x => x.scenarioId !== scenarioId);
  },
  updateScenario(state, scenario) {
    state.scenarios = state.scenarios.map(x => x.scenarioId !== scenario.scenarioId ? x : scenario);
  },
  addInstruction(state, instruction) {
    state.instructions.push(instruction);
  },
  deleteInstruction(state, instructionId) {
    state.instructions = state.instructions.filter(x => x.instructionId !== instructionId);
  },
  updateInstruction(state, instruction) {
    state.instructions = state.instructions.map(x => x.instructionId !== instruction.instructionId ? x : instruction);
  },
  addSchedule(state, schedule) {
    state.schedules.push(schedule);
  },
  updateSchedule(state, schedule) {
    state.schedules = state.schedules.map(x => x.instructionId !== schedule.instructionId ? x : schedule);
  },
  deleteSchedule(state, instructionId) {
    state.schedules = state.schedules.filter(x => x.instructionId !== instructionId);
  },
  updateScheduleNameColor(state, contex) {
    state.schedules[contex.scheduleIndex].name = contex.name;
    state.schedules[contex.scheduleIndex].color = contex.color;
  },
  updateScheduleTimeEvent(state, contex) {
    state.schedules[contex.scheduleIndex].timeEvent.dateStamp = contex.timeEvent.dateStamp;
    state.schedules[contex.scheduleIndex].timeEvent.timeStamp = contex.timeEvent.timeStamp;
    state.schedules[contex.scheduleIndex].timeEvent.repeatMask = contex.timeEvent.repeatMask;
  },
  updateScheduleActive(state, contex) {
    state.schedules[contex.scheduleIndex].active = contex.active;
  },
  updateScheduleCommand(state, contex) {
    state.schedules[contex.scheduleIndex].scheduleCommand = contex.scheduleCommand;
  },

  //Notification Related
  addNotification(state, notification) {
    state.notifications.push(notification);
  },
  deleteNotification(state, notificationIndex) {
    state.notifications.splice(notificationIndex, 1);
  },
  deleteNotificationByEventId(state, eventId) {
    for (let i=0; i < state.notifications.length; i++){
      let notification = state.notifications[i];
      if (notification.eventId == eventId) {
        state.notifications.splice(i, 1);
        return;
      }
    }
  },
  editOrAddNotificationByEventId(state, newNotification) {
    let found = false;
    for (let i=0; i < state.notifications.length; i++){
      let notification = state.notifications[i];
      if (notification.eventId == newNotification.eventId) {
        state.notifications[i] = newNotification;
        found = true
        console.log("found");
        break;
      }
    }
    if (!found){
      state.notifications.push(newNotification);
    }
  },
}
export default MUTATIONS;